module.exports = __webpack_public_path__ + "img/british_quality_foundation.93b27458.png";